import {
  faDashboard,
  faUser,
  faKey,
  faBuilding,
  faHome,
  faCheckCircle,
  faThLarge,
  faStore,
  faMoneyBill,
  faUsersCog,
  faBars,
  faListUl,
  faHistory,
} from "@fortawesome/free-solid-svg-icons";



const userManagementSidebarItems = {

  user: {
    path: "/userManagement/user",
    icon: faStore,
    sidebarText: "Buyer/Seller",
  },

  investor: {
    path: "/userManagement/investor",
    icon: faMoneyBill,
    sidebarText: "Investor",
  },

  agent: {
    path: "/userManagement/agent",
    icon: faMoneyBill,
    sidebarText: "Agent",
  },

  lawyer: {
    path: "/userManagement/lawyer",
    icon: faMoneyBill,
    sidebarText: "Lawyer",
  },

  evaluator: {
    path: "/userManagement/evaluator",
    icon: faMoneyBill,
    sidebarText: "Evaluator",
  },
};



const accountsManagementSidebarItems = {

  user: {
    path: "/accountsManagement/user",
    icon: faStore,
    sidebarText: "Buyer/Seller",
  },

  investor: {
    path: "/accountsManagement/investor",
    icon: faMoneyBill,
    sidebarText: "Investor",
  },

  agent: {
    path: "/accountsManagement/agent",
    icon: faMoneyBill,
    sidebarText: "Agent",
  },

  lawyer: {
    path: "/accountsManagement/lawyer",
    icon: faMoneyBill,
    sidebarText: "Lawyer",
  },

  evaluator: {
    path: "/accountsManagement/evaluator",
    icon: faMoneyBill,
    sidebarText: "Evaluator",
  },
  
};


const accessManagementSidebarItems = {
  roleManagement: {
    path: "/RoleManage",
    icon: faUsersCog,
    sidebarText: "Role Management",
  },
  managerList: {
    path: "/managers",
    icon: faListUl,
    sidebarText: "Manager List",
  },
};

const investorManagementSidebarItems = {

   investorsDashboard: {
    path:"/Prop-InvestorDashboard",
    icon: faUsersCog,
    sidebarText: "Admin Dashboard",
  },

  investors: {
    path: "/investors",
    icon: faUsersCog,
    sidebarText: "Pool Managment",
  },

  investorManagment: {
    path:  "/investors/management",
    icon: faListUl,
    sidebarText: "Transaction Managment",
  },

  investorRelations: {
    path:  "/investors/relations",
    icon: faListUl,
    sidebarText: "Investor Relations",
  },

};


const subscriptionPlanSidebarItes = {
  userSub: {
    path: "/subscription",
    icon: faStore,
    sidebarText: "User(Seller)",
  },  

  investorSub: {
    path: "/subscription/investor",
    icon: faMoneyBill,
    sidebarText: "Investor",
  },

  lawyerSub: {
    path: "/subscription/lawyer",
    icon: faStore,
    sidebarText: "Lawyer",
  },
  agentSub: {
    path: "/subscription/agent",
    icon: faMoneyBill,
    sidebarText: "Agent",
  },
  evaluatorSub: {
    path: "/subscription/evaluator",
    icon: faStore,
    sidebarText: "Evaluator",
  },
};

const subscriptionSidebarItems = {

  subscriptionPlan: {
    path: "#",
    icon: faThLarge,
    sidebarText: "Subscription Plan",
    children: subscriptionPlanSidebarItes,
  },

  subscriptionHistory: {
    path: "#",
    icon: faHistory,
    sidebarText: "Subscription History",
  },

};


export const sideBarItems = {

  dashBoard: {
    sidebarText: "Dashboard",
    icon: faDashboard,
    path: "/Dashboard",
    children: null, 
  },

  userManagement: {
    sidebarText: "User Management",
    icon: faUser,
    path: "#",
    children: userManagementSidebarItems,
  },

  accessManagement: {
    sidebarText: "Access Management",
    icon: faKey,
    path: "#",
    children: accessManagementSidebarItems,
  },

  // accountsManagement: {
  //   sidebarText: "Account Management",
  //   icon: faMoneyBill,
  //   path: "#",
  //   children: accountsManagementSidebarItems,
  //   // children: null,
  // },
  // subscription: {
  //   sidebarText: "Subscription",
  //   icon: faBuilding,
  //   path: "#",
  //   children: subscriptionSidebarItems,
  // },

  investoryManagement: {
    sidebarText: "PropInvestor",
    icon: faBuilding,
    path: "#",
    children: investorManagementSidebarItems,
  },

  propertyListing: {
    sidebarText: "Property Listing",
    icon: faHome,
    path: "/property-listing",
    children: null,
  },

  propertyVerification: {
    sidebarText: "Property Verification",
    icon: faCheckCircle,
    path: "/property-verification",
    children: null,
  },
  // lmsTraining: {
  //   sidebarText: "LMS Training",
  //   icon: faHome,
  //   path: "#",
  //   children: null,
  // },
  paymentRequest: {
    sidebarText: "Payment Request",
    icon: faMoneyBill,
    path: "/paymentrequest",
    children: null,
  },
  transactions: {
    sidebarText: "Transactions",
    icon: faMoneyBill,
    path: "/transactions",
    children: null,
  },
      support:{
       sidebarText:"Support",
       icon:faHome,
       path:'/support',
       children:null,
      },

     overdueTasks: {
    sidebarText: "Overdue Tasks",
    icon: faMoneyBill,
    path: "/support",
    children: null,
  },
    
  
// investors:{
//   sidebarText:"Investors",
//   icon:faMoneyBill,
//   path:'/investors',
//   children:null,  
// },
};
